import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { i18n } from '../lang/config';

const globalStore = {
  toastrAlert: {
    alertPosition: 'top-right',
    alertduration: 5000
  },
  calfGenderList: [
    {
      type: 'X',
      desc: i18n.t('unknown')
    },
    {
      type: 'F',
      desc: i18n.t('female')
    },
    {
      type: 'M',
      desc: i18n.t('male')
    }
  ],
  period: {
    default: {
      maxPeriodCount: 15,
      maxDailyFeeding: 25000
    },
    selected: {
      periodCount: 3,
      dailyFeeding: 7500,
      periodMaxFeeding: 2500
    }
  },
  externalFeedingAddr: {
    manual: { type: 'M', addr: 0 },
    trigger: { type: 'M', addr: 503 },
    control: { type: 'M', addr: 520 },
    water: { type: 'D', addr: 300 },
    food: { type: 'D', addr: 302 }
  },
  calfType: ['SIMMENTAL', 'MONTBELIARDE', 'BROWN SWISS', 'SWEDISH RED', 'ANGUS', 'BELGIUM BLUE', 'HEREFORD', 'LIMOUSIN', 'CHAROLAIS', 'MANDA', 'JERSEY', 'SWEDISH BROWN', 'HOLSTEİN'],
  calibrations: {
    calf: {
      calfPeriodDetailsFeeding: {
        min: 1000,
        max: 5000,
        step: 250,
        default: 2500
      },
      calfPeriodDetailsLimit: {
        min: 0,
        max: 1500,
        step: 250,
        default: 1000
      },
      calfFeedingMaxDayCount: 90
    }
  },
  calfFilterList: [
    {
      value: 'all',
      name: i18n.t('op.showAll')
    },
    {
      value: 'calfTitle',
      name: i18n.t('calf.input.sortByTitle')
    },
    {
      value: 'time',
      name: i18n.t('calf.input.sortByDate')
    },
    {
      value: 'remainingDay',
      name: i18n.t('calf.byRemainingDays')
    },
    {
      value: 'consumption',
      name: i18n.t('calf.byConsumption')
    }]
};

var store = createStore({
  state: {
    ...globalStore,
    roboConfig: {
      license: true,
      stationCount: 0, // servislerden gelir
      code: 'CFR_0000_TR_00',
      stationCalfLimit: 30,
      virtual: {}
    },
    auth: {
      authority: true,
      tecnicalPersonal: true,
      role: undefined,
      mail: undefined,
      authorization: [],
      authList: []
    },
    powerLogDesc: {
        'charge': 'Şarj',
        'tour': 'Tur'
    },
    selected_machine: undefined,
    machine_data: undefined,
    notificationMethodList: [
      {
        type: 'T',
        desc: 'Telegram'
      },
      {
        type: 'S',
        desc: 'SMS'
      }
    ],
    lang: localStorage.lang,
    systemDate: '', // servislerden gelir
    stationMonitoring: [], // servislerden gelir
    rfidMonitoring: [], // servislerden gelir
    liquidDiffList: [], // servislerden gelir
    controlPLC: {}, // servislerden gelir
    plcDelayList: [], // servislerden gelir
    services: [], // servislerden gelir
    allServiceData: undefined, // servislerden gelir
    producer: undefined, // servislerden gelir
    systems: undefined // servislerden gelir
  },
  getters: {
    // get
  },
  mutations: {
    // set
    collapse() {
      if (document.querySelector('body').classList != 'collapse') {
        document.querySelector('body').classList.add('collapse');
        document.getElementById('logo-big').classList.add('d-none');
        document.getElementById('logo-small').classList.remove('d-none');
      } else {
        document.querySelector('body').classList.remove('collapse');
        document.getElementById('logo-big').classList.remove('d-none');
        document.getElementById('logo-small').classList.add('d-none');
      }
    },
    fullScreen() {
      if ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          /* Firefox */
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          /* Chrome, Safari & Opera */
          document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (document.msRequestFullscreen) {
          /* IE/Edge */
          document.documentElement.msRequestFullscreen();
        }
        // document.querySelector("#fsBtn").firstChild.classList.remove("fa-expand-arrows-alt", "zoom");
        // document.querySelector("#fsBtn").firstChild.classList.add("fa-compress-arrows-alt", "fs-5", "re-zoom");
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          /* Chrome, Safari and Opera */
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
        // document.querySelector("#fsBtn").firstChild.classList.remove("fa-compress-arrows-alt", "fs-5", "re-zoom");
        // document.querySelector("#fsBtn").firstChild.classList.add("fa-expand-arrows-alt", "zoom");
      }
    },
    navOptionsBar() {
      document.getElementById('navOptionsBar').classList.toggle('open');
    },
    async logout() {
      this.state.auth = {
        authority: false,
        role: undefined,
        mail: undefined,
        authorization: [],
        authList: []
      }
      localStorage.removeItem('token')
      localStorage.removeItem('selected_machine')
    }
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState()]
});

export default store;
